<app-pdf-page>
  <app-pdf-page-header>{{ pdfDetails.projectDetails.name }}</app-pdf-page-header>
  <h1 class="pdf-page__project-title">{{ (projectintakeOnly ? 'PAGE_FILL_QUICKSCAN.title' : 'PAGE_PROJECT_ANALYSIS_QUESTIONS.title') | translate }}</h1>
  <small class="header-subtitle">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.version' | translate }}
  : {{ pdfDetails.projectAnalysisDefinition?.versionId }}</small>

  <div class="grid-spacer grid-spacer--large"></div>
  @for (category of categories; track trackCategory(categoryIndex, category); let categoryIndex = $index) {
    <div class="prevent-pagebreak-inside">
      <vwui-table [compactable]="false">
        <div slot="table-title">{{ categoryIndex + 1 }}. {{ category.name }}</div>
        <vwui-table-row>
          <vwui-table-header class="table-col table-col--nr">{{ 'PAGE_FILL_TIS.table.column.number' | translate }}</vwui-table-header>
          <vwui-table-header class="table-col table-col--question">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.table.column.question' | translate }}</vwui-table-header>
          <vwui-table-header class="table-col table-col--answer">{{ 'PAGE_PROJECT_ANALYSIS_QUESTIONS.table.column.answer' | translate }}</vwui-table-header>
        </vwui-table-row>
        @for (question of category.questions; track trackQuestion(questionIndex, question); let questionIndex = $index) {
          @if (showQuestion(question)) {
              <vwui-table-row>
                  <vwui-table-column class="table-col table-col--nr">{{ categoryIndex + 1 }}.{{ questionIndex + 1 }}</vwui-table-column>
                  <vwui-table-column class="table-col table-col--question">{{ question.title || question.name }}</vwui-table-column>
                  <vwui-table-column class="table-col table-col--answer">{{ getAnswer(question) }}</vwui-table-column>
              </vwui-table-row>
              @if (getExplanation(question)) {
                  <vwui-table-row class="table-row table-row--attachments">
                      <vwui-table-column></vwui-table-column>
                      <vwui-table-column class="table-col table-col--question">
                          {{ 'COMPONENT.quickscan_list.explanation' | translate }}
                      </vwui-table-column>
                      <vwui-table-column class="table-col table-col--answer">{{ getExplanation(question) }}</vwui-table-column>
                  </vwui-table-row>
              }
          }
       }
      </vwui-table>
      <div class="grid-spacer grid-spacer--large"></div>
    </div>
  }
  <app-pdf-page-footer><app-classification></app-classification></app-pdf-page-footer>
</app-pdf-page>
